import { useContext, createContext } from 'react';

interface ContextType {
  optional?: boolean;
}

const Context = createContext<ContextType>({});
export const InputContextProvider = Context.Provider;
export const useInputContext = () => useContext(Context);
